import { IVasVariant } from '@r1-frontend/api-domru/api-vas/v1/vas/byShopItemId/dto/responseDto';

import { IAction } from '~/src/store';

import { ESpeedBonusActions } from './constants';

export interface ISpeedBonusTariff {
    // activation
    socId: number,
    bonusId: number,
    speedBonusStatus: number,
    specialOffersRequestIds?: number[],
    // fetch routers
    speed?: number,
    // UI
    title: string,
    price: number,
    // analytics
    connectionFlow: IVasVariant['connectionFlow'],
    shopItemId: number,
}

export const setTariff = (tariff: ISpeedBonusTariff): IAction<ESpeedBonusActions.setTariff, ISpeedBonusTariff> => ({
    type: ESpeedBonusActions.setTariff,
    payload: tariff,
});
